import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { MassUseMerchantModel, MassUseMerchantPayloadModel } from 'Pages/pp'

export const massUseMerchantApi = {
	createOne: async (data: MassUseMerchantModel) => {
		const res = await axiosDS().post<MassUseMerchantPayloadModel>(
			urls.pp.mass_use_merchant.create,
			{
				data,
			}
		)
		return res.data
	},
	deleteOne: async (data: MassUseMerchantModel) => {
		const res = await axiosDS().post<MassUseMerchantPayloadModel>(
			urls.pp.mass_use_merchant.delete,
			{
				data,
			}
		)
		return res.data
	},
}
